import {useOktaAuth} from '@okta/okta-react';

export const useAuth = () => {
  const {oktaAuth, authState} = useOktaAuth();

  return {
    authState,
    getUser: oktaAuth.getUser.bind(oktaAuth),
    setOriginalUri: oktaAuth.setOriginalUri.bind(oktaAuth),
    login: oktaAuth.signInWithRedirect.bind(oktaAuth),
    logout: async () => {
      try {
        await oktaAuth.signOut({
          clearTokensBeforeRedirect: true,
          revokeAccessToken: true,
          revokeRefreshToken: true,
        });
      } catch (error) {
        // If token revocation fails, still proceed with signOut
        // This can happen in local dev or if Okta client doesn't have revoke permissions
        try {
          await oktaAuth.signOut({
            clearTokensBeforeRedirect: true,
          });
        } catch (fallbackError) {
          // If signOut itself fails (network error, Okta down), manually clear tokens
          oktaAuth.tokenManager.clear();
        }
      }
    },
  };
};
